export default __webpack_public_path__ + "static/media/molnar_zoltan.a1cc4cb5.webp";